import React, { ChangeEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../../../store";
import { Data as CustomGroupData } from "../../../../../store/customGroup/types";
import Autocomplete from "@mui/material/Autocomplete";
import { Box, Button, Grid, TextField } from "@mui/material";
import { Add } from "@mui/icons-material";
import { Field, FormikProps, useFormikContext } from "formik";
import { Data } from "../../../../../store/terminal/types";
import CustomGroupDialog from "../../../../customGroup/customGroupDialog/CustomGroupDialog";
import CustomGroupAdd from "../../../../customGroup/customGroupAdd/CustomGroupAdd";
import { fetchRequest as fetchCustomGroups } from "../../../../../store/customGroup/actions";
import useUserAccess from "./../../../../../effects/useUserAccess";
import { isEmpty, isNil } from "ramda";
import { get } from "lodash";

interface Props {
  isUpdateAllowed?: boolean;
}

const EditCustomGroups = ({ isUpdateAllowed }: Props) => {
  const dispatch = useDispatch();
  const access = useUserAccess();
  const isCreateGroupAllowed = get(access, "Group.Access.C") && isUpdateAllowed;
  const isTerminalUpdateAllowed =
    get(access, "Terminal.Access.U") && isUpdateAllowed;

  const formikProps = useFormikContext<FormikProps<Data>>();
  const { setFieldValue } = formikProps;
  const values = (formikProps.values as unknown) as Data;

  const [openAddCustomGroupDialog, setOpenAddCustomGroupDialog] = useState(
    false
  );
  const [isGroupAddedSuccess, setIsGroupAddedSuccess] = useState(false);

  // get all groups from state
  const allGroups =
    (useSelector<ApplicationState>(
      (store) => store.customGroup.data?.data
    ) as CustomGroupData[]) || [];

  // fetch new groups incase we add new one
  useEffect(() => {
    dispatch(fetchCustomGroups(null));
  }, [isGroupAddedSuccess]);

  // handle update add new group status
  const handleAddGroupStatus = () => {
    setIsGroupAddedSuccess(!isGroupAddedSuccess);
  };

  // update values of attributes.groups
  const handleOnChange = (newGroup: CustomGroupData[]) => {
    setFieldValue(
      "attributes.groups",
      newGroup.map((group) => group.groupId)
    );
  };

  const handleOpenDialog = () => {
    setOpenAddCustomGroupDialog(!openAddCustomGroupDialog);
  };

  return (
    <>
      <Grid xs={12}>
        {allGroups && allGroups.length ? (
          <Field name="attributes.groups">
            {() => {
              return (
                <Autocomplete
                  key={allGroups.length}
                  multiple
                  fullWidth
                  id="custom-groups"
                  options={allGroups}
                  getOptionLabel={(option) => option.name}
                  defaultValue={
                    allGroups.filter((group) =>
                      values.attributes.groups?.includes(group.groupId)
                    ) || []
                  }
                  filterSelectedOptions
                  onChange={(e: ChangeEvent<{}>, newGroup: CustomGroupData[]) =>
                    handleOnChange(newGroup)
                  }
                  disabled={!isTerminalUpdateAllowed}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Seleted Groups"
                      placeholder="Select group"
                    />
                  )}
                />
              );
            }}
          </Field>
        ) : (
          <Box textAlign="center">There is no custom group</Box>
        )}
      </Grid>
      <Grid xs={12}>
        <Box textAlign="center">
          {isCreateGroupAllowed ? (
            <Button
              color="primary"
              variant="contained"
              size="medium"
              endIcon={<Add />}
              onClick={handleOpenDialog}
              style={{ marginTop: "15px" }}
            >
              Create a Group
            </Button>
          ) : null}

          {openAddCustomGroupDialog ? (
            <CustomGroupDialog
              title="Add Custom Group"
              isOpen={openAddCustomGroupDialog}
              onClose={handleOpenDialog}
            >
              <CustomGroupAdd
                setSubmitStatus={handleAddGroupStatus}
                closeDialog={handleOpenDialog}
              />
            </CustomGroupDialog>
          ) : null}
        </Box>
      </Grid>
    </>
  );
};

export default EditCustomGroups;
